import { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) { setUser(null); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("auth_token");
      setUser(null);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("auth_token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role, extra_roles: data.extra_roles || [] });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout failed", e); }
    localStorage.removeItem("auth_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Effective roles = primary role + super-admin-assigned extra roles (permission union).
export const userRoles = (user) => [user?.role, ...(user?.extra_roles || [])].filter(Boolean);
export const hasAnyRole = (user, roles) => userRoles(user).some((r) => roles.includes(r));

export const useAuth = () => useContext(AuthContext);
